import React from 'react'
import logo from '../../../assets/appLogo.png'
import { useNavigate } from 'react-router-dom'

const NavBar = () => {
  const navigate=useNavigate()
  return (
    <div className='get-started-navbar'>
        <img src={logo} className='app-image' alt="app-logo" onClick={()=>navigate("/")}/>
        {/* <p>Have an account ? <span className='registration-link-text' onClick={()=>navigate("/login")}>Sign in</span></p> */}
    </div>
  )
}

export default NavBar